export default {
  sm: `
  오늘의 기록을<br>내일의 혁신으로
  `,
};
